/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $btnExpand   = $el.find('.btn-expand');
const $subscribers = $el.find('.wrap-subscribers');
const $subscriber  = $subscribers.find('.subscriber');

const $btnTxt  = $btnExpand.find('.txt');
const $btnIcon = $btnExpand.find('.icon');

let expanded = false;

const initialHeight = 405;
const subscribersHeight = $subscriber.outerHeight() * $subscriber.length + 35;

if (subscribersHeight < initialHeight) {
    $subscribers.height('auto');
    $subscribers.addClass('loss');
    $btnExpand.hide();
}

$btnExpand.on('click', function() {
    if (expanded === false) {
        $subscribers.addClass('expand');
        $subscribers.height(subscribersHeight);

        $btnTxt.html('Retrair lista de inscritos');
        $btnIcon.html('-');
        $btnIcon.addClass('minus');

        expanded = true;
    } else {
        $subscribers.removeClass('expand');
        $subscribers.removeAttr('style');

        $btnTxt.html('Expandir lista de inscritos');
        $btnIcon.removeClass('minus');
        $btnIcon.html('+');

        expanded = false;
    }
});
